import { ChangeDetectorRef, Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NotificationTokenInterface } from 'src/app/interfaces/notification-token.interface';
import { AppService } from 'src/app/services/app.service';
import { BDODataService } from 'src/app/services/bdo-data.service';
import { ContractsService } from 'src/app/services/contracts.service';
import { LoadingSpinnerService } from 'src/app/services/loading-spinner.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { StorageService } from 'src/app/services/storage.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss'],
})
export class ShowComponent {
  constructor(
    public titleService: Title,
    public notificationsService: NotificationsService,
    public appService: AppService,
    private permissionsService: PermissionsService,
    private router: Router,
    private loadingSpinnerService: LoadingSpinnerService,
    private contractsService: ContractsService,
    private bdoDataService: BDODataService,
    private changeDetectorRef: ChangeDetectorRef,
    private storageService: StorageService,
    private utilityService: UtilityService
  ) {}

  async ngOnInit() {
    if (!this.loadingSpinnerService.lockQuery()) {
      return;
    }

    // FIREFOX ISSUE - loading spinner at the start of the page, turns in a big black filled circle, without the setTimeout(0)
    setTimeout(async () => {
      await this.loadingSpinnerService.animateQuery();
      const promises = [];

      promises.push(this.contractsService.loadProfileData());
      promises.push(this.bdoDataService.loadBDOData());

      if (this.appService.isNativePlatform) {
        promises.push(this.permissionsService.loadPermissions());
        promises.push(this.sendNotificationToken());
      }

      if (!this.permissionsService.hasRestrictedAccess) {
        promises.push(this.notificationsService.checkForNewNotifications());
      }

      const promiseResults = await Promise.allSettled(promises);
      if (promiseResults.some((result) => result.status === 'rejected')) {
        await this.utilityService.showServerErrorToast();
      }

      this.changeDetectorRef.detectChanges();
      await this.loadingSpinnerService.stopAnimateQuery();
      this.loadingSpinnerService.unlockQuery();
      this.appService.areCoreFeaturesLoaded = true;
      this.appService.areCoreFeaturesLoaded$.next(true);
    }, 0);
  }

  public moveToNotificationsPage(): void {
    if (this.permissionsService.hasRestrictedAccess) {
      this.router.navigate(['/show/blocked-feature']);
    } else {
      this.router.navigate(['/show/notifications']);
    }
  }

  public logout(): void {
    this.router.navigate(['/auth'], { replaceUrl: true });
  }

  private async sendNotificationToken(): Promise<void> {
    const notificationToken = this.storageService.get('pushNotificationToken');
    const phone = this.storageService.get('phoneNumber');
    const notificationTokenDto: NotificationTokenInterface = {
      numerTelefonu: phone,
      tokenPowiadomien: notificationToken,
    };

    await this.notificationsService.sendNotificationToken(notificationTokenDto);
  }
}
